import { CircleAlert, Info, LogOut, Octagon, OctagonAlert, OctagonX, ShieldAlert, Square, TriangleAlert, X } from "lucide-react";
import { useNotify, Severity } from "@/contexts/NotifyContext";
import { useAuth } from "@/contexts/AuthContext";

export const Notify: React.FC = () => {
  const { signout } = useAuth();
  const { notify, setNotify } = useNotify();  
  
  let icon = <></>;
  let closeButton = <></>;
  let message = null;
  let subMessage = null;

  const handleClose = () => {
    switch(notify?.error.status) {
      case 401: // Unauthorized
      case 440: // Session Expired
        signout();
        break;
    }
    setNotify(null);
  }
  
  // console.log("notify", notify);

  if (!notify)
    return null
  else {
    message = notify.error?.response?.data?.message || notify.error?.message || String(notify.error)
    switch(notify.severity) {
      case 'info':
        icon = <Info className="w-6 h-6 text-blue-600 shrink-0 mt-0.5" />;
        break;
      case 'warning':
        icon = <CircleAlert className="w-6 h-6 text-yellow-600 shrink-0 mt-0.5" />;
        break;
      case 'error':
        icon = <ShieldAlert className="w-6 h-6 text-red-600 shrink-0 mt-0.5" />;
        break;
      case 'critical':
        icon = <TriangleAlert className="w-6 h-6 text-red-600 shrink-0 mt-0.5" />;
        break;
      default: 
        icon = <svg className="w-6 h-6 text-red-600 shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>;
        break;
      }

      switch(notify?.error.status) {
        case 401: // Unauthorized
        case 440: // Session Expired
          closeButton = <LogOut className="w-5 h-5" />;
          subMessage = "Please logout and re-login "
          break;
        case 500: // Internal Server Error
        case 503: // Service Unavailable
        default:
          closeButton = <X className="w-5 h-5" />;
          break;
      }

    }
    return (
      <div className="mt-4 p-4 bg-red-50 border border-red-200 rounded-lg flex items-start gap-3">
        {icon}
        <div className="flex-1">
          <h4 className="font-semibold text-red-800 mb-1">{notify.title}</h4>
          <p className="text-sm text-red-700">{message}</p>
          {subMessage && <p className="text-xs text-red-700">{subMessage}</p>}
        </div>
        <button onClick={handleClose}>
          {closeButton}
        </button>
      </div>
    );
  
};